import _isEmpty from "lodash/isEmpty"
import _get from "lodash/get"

import { STORE_MAX_DISTANCE, STORE_MIN_DISTANCE } from "@/constants"
import { apim } from "@/constants/api"
import { locationIpEndPoint, locationZipEndPoint } from "@/constants/index"
import { getConfig } from "@/constants/config"
import { aemClientAxiosInstance } from "@/services/client/aem.client"
import { findStoreUtilNavselectQuery } from "@/utils"
import {
  getRegexPattern,
  getRegexValidationMessage,
} from "@/utils/regexPattern"

import { store } from "@/store"

// Get location using the public ip address of the client
const getLocationUsingIP = async () => {
  try {
    const ip = window?.sessionStorage["true-ip"]
    if (ip && ip !== "") {
      // {"23.100.225.115"}
      const res = await apim.get(`${locationIpEndPoint}${ip}`)
      return res
    } else {
      return {}
    }
  } catch (err) {
    console.error("Failed to get location using IP address", err)
  }
}

// Get location using the zip code
const getLocationUsingZipcode = async zip => {
  try {
    if (zip && zip !== "") {
      const res = await apim.get(`${locationZipEndPoint}${zip}`)
      return res
    } else {
      return {}
    }
  } catch (err) {
    console.error("Failed to get location using zipcode", err)
  }
}

const validateField = async (field, value) => {
  const config = await getConfig()
  const { regexPattern } = config
  const pattern = getRegexPattern(_get(regexPattern, `map.${field}`, ""))
  const regex = new RegExp(pattern)
  const isValid = regex.test(value) ? true : false
  return isValid
}

export const validateInputField = (field, value) => {
  const {
    generic: { globalConfig: { regexPattern: { map } = {} } = {} } = {},
  } = store.getState()

  const pattern = getRegexPattern(map[field])
  const regex = new RegExp(pattern)
  const isValid = regex.test(value)
  return isValid
}

export const getFieldValidationMessage = field => {
  const {
    generic: { globalConfig: { regexPattern: { map = {} } = {} } = {} } = {},
  } = store.getState()
  return getRegexValidationMessage(map[field])
}

const validateZip = async zip => {
  const res = await getLocationUsingZipcode(zip)
  if (
    res?.data?.resourceSets &&
    res?.data?.resourceSets[0]?.resources[0]?.address?.postalCode === zip
  )
    return true
  return false
}

const getShortenedUrl = async uUrl => {
  const config = await getConfig()
  const { general } = config
  const shortUrl = general?.shortendPagePath ?? ""
  const htmlRegExp = new RegExp(".html", "g")
  const htmlRemovedUrl = `${uUrl?.replace(htmlRegExp, "")}`
  const shortUrlRegEx = new RegExp(shortUrl, "g")
  return `${htmlRemovedUrl?.replace(shortUrlRegEx, "")}`
}

const getStoreDataById = ({ myStoreId, findStores, siteName }) => {
  return new Promise((resolve, reject) => {
    const selectQuery = findStoreUtilNavselectQuery
    if (!_isEmpty(findStores)) {
      apim
        .get(findStores, {
          params: {
            $format: "json",
            brand: siteName.toLowerCase(),
            $select: selectQuery,
            $filter: `EntityID Eq ('${myStoreId}')`,
          },
        })
        .then(response => {
          if (response && response.data) {
            resolve(response.data.d.results[0] ?? {})
          } else {
            reject(
              new Error(
                "Find a nearest store: Error occured while fetching data from Get URL Property"
              )
            )
            // log.error(
            //   "Find a nearest store: Error occured while fetching data from Get URL Property"
            // )
          }
        })
        .catch(err => {
          console.log({ err })
          reject(
            new Error(
              "Find a nearest store: Error occured while fetching data from Get URL Property"
            )
          )
        })
      // .catch(err => log.error(err))
    } else {
      // log.error("Find a nearest store: Get API config not found")
    }
  })
}

const getStoreDataByDistance = ({
  utilityDistance = STORE_MIN_DISTANCE,
  findStores,
  userCity,
  siteName,
}) => {
  return new Promise((resolve, reject) => {
    // const locationStore = store.getState()?.location || ""
    // console.log({ locationStore })
    const selectQuery =
      "EntityID,BPnumber,LocationName,AddressLine,AddressLine2,StateLong,AdminDistrict,PostalCode,Latitude,__Distance,Longitude,Phone,OpenUntil,Locality"
    if (!_isEmpty(findStores)) {
      apim
        .get(findStores, {
          params: {
            $format: "json",
            brand: siteName.toLowerCase(),
            spatialFilter: `nearby('${userCity}',${utilityDistance})`,
            $select: selectQuery,
            $filter: "LocationType Eq ('KOHLER Store')",
          },
        })
        .then(response => {
          if (response && response.data) {
            if (!_isEmpty(response.data.d.results[0])) {
              const utilityData = response.data.d.results[0]
              resolve(utilityData)
            } else if (utilityDistance === 64) {
              getStoreDataByDistance({
                utilityDistance: STORE_MAX_DISTANCE,
                findStores,
                userCity,
              })
            }
          } else {
            reject(
              new Error(
                "Find a nearest store: Error occured while fetching data from Get URL Property"
              )
            )
            // log.error(
            //   "Find a nearest store: Error occured while fetching data from Get URL Property"
            // )
          }
        })
        .catch(err => {
          console.log({ err })
          // log.error(err)
        })
    } else {
      // log.error("Find a nearest store: Get API config not found")
    }
  })
}

const utilityStoreDetailsRequests = new Map()

const getUtilityStoreDetails = ({ utilityStoreDetailsUrl }) => {
  if (!utilityStoreDetailsUrl) {
    return Promise.reject(
      new Error("Store Details: servlet path config not found")
    )
  }

  const existingRequest = utilityStoreDetailsRequests.get(
    utilityStoreDetailsUrl
  )
  if (existingRequest) return existingRequest

  const request = aemClientAxiosInstance
    .get(utilityStoreDetailsUrl)
    .then(response => {
      if (
        !response?.data ||
        typeof response.data !== "object" ||
        Array.isArray(response.data)
      ) {
        throw new Error("Store Details: invalid response")
      }
      return response.data
    })
    .finally(() => {
      if (utilityStoreDetailsRequests.get(utilityStoreDetailsUrl) === request) {
        utilityStoreDetailsRequests.delete(utilityStoreDetailsUrl)
      }
    })

  utilityStoreDetailsRequests.set(utilityStoreDetailsUrl, request)
  return request
}

export {
  getLocationUsingIP,
  getLocationUsingZipcode,
  validateField,
  validateZip,
  getShortenedUrl,
  getStoreDataById,
  getStoreDataByDistance,
  getUtilityStoreDetails,
}
